/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Calendar_MicrosoftInputs */

const cs_settings_calendar_microsoft = /** @type {(inputs: Settings_Calendar_MicrosoftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microsoft Outlook`)
};

const en_settings_calendar_microsoft = /** @type {(inputs: Settings_Calendar_MicrosoftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microsoft Outlook`)
};

/**
* | output |
* | --- |
* | "Microsoft Outlook" |
*
* @param {Settings_Calendar_MicrosoftInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_calendar_microsoft = /** @type {((inputs?: Settings_Calendar_MicrosoftInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Calendar_MicrosoftInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendar_microsoft(inputs)
	return cs_settings_calendar_microsoft(inputs)
});